import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { t } from "i18next";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { cloneDeep, debounce } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { useTranslation } from "react-i18next";
import { treeActions } from "../../../redux/slices/treeSlice";
import TPCheckbox from "../../TemplateProperties/TPCheckbox";

function JSONRecordProperties() {
  const { t } = useTranslation();
  const obFormattingOptions = [
    { title: t("EMPTY_RECORD_EMPTY"), value: "EMPTY" },
    { title: t("EMPTY_RECORD_REPLACE_WITH_NULL"), value: "REPLACE_WITH_NULL" },
    { title: t("EMPTY_RECORD_REMOVE"), value: "REMOVE" },
  ];
  const [obFormatting, setObFormatting] = useState("");
  const [suppressArray, setSuppressArray] = useState(false);
  const [suppressArrayNameandBraces, setSuppressArrayNameandBraces] =
    useState(false);
  const [suppressArrayName, setSuppressArrayName] = useState(false);
  const [suppressArrayBraces, setSuppressArrayBraces] = useState(false);

  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const { translatedData, selectedNode } = rightTree.tree[currentTab];

  useEffect(() => {
    setObFormatting(selectedNode.EMPTY_ACTION || obFormattingOptions[0].value);
    setSuppressArray(selectedNode.SUPPRESS_ARRAY === "TRUE" || false);
    setSuppressArrayNameandBraces(
      selectedNode.SUPPRESS_ARRAY_NAME === "TRUE" || false
    );
    setSuppressArrayName(
      selectedNode.hasOwnProperty("SUPPRESS_ARRAY_NAME") &&
        selectedNode?.SUPPRESS_ARRAY_NAME === "TRUE"
        ? true
        : selectedNode.SUPPRESS_ARRAY_NAME_ONLY === "TRUE"
        ? true
        : false
    );
    setSuppressArrayBraces(
      selectedNode.hasOwnProperty("SUPPRESS_ARRAY_NAME") &&
        selectedNode?.SUPPRESS_ARRAY_NAME === "TRUE"
        ? true
        : selectedNode.SUPPRESS_BRACES === "TRUE"
        ? true
        : false
    );
  }, [selectedNode?.key, selectedNode]);

  // useEffect(() => {
  //   debounceChangeHandler(null, null, {
  //     SUPPRESS_ARRAY_NAME: suppressArrayNameandBraces ? "TRUE" : "FALSE",
  //     SUPPRESS_ARRAY_NAME_ONLY: "FALSE",
  //     SUPPRESS_BRACES: "FALSE",
  //   });
  //   setSuppressArrayBraces(false);
  //   setSuppressArrayName(false);
  // }, [suppressArrayNameandBraces]);

  const submitChange = (key, value, bulk) => {
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key !== selectedNode.key) return;
      if (key) obj[key] = value;
      else {
        Object.keys(bulk).forEach((e) => {
          obj[e] = bulk[e];
        });
      }
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: obj,
        })
      );
    });
    dispatch(
      treeActions.setRightTreeTransData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };
  const debounceChangeHandler = useCallback(debounce(submitChange, 300), [
    rightTree.currentTab,
    rightTree.tree,
    translatedData,
  ]);

  useEffect(() => {
    return () => {
      debounceChangeHandler.cancel();
    };
  }, [debounceChangeHandler]);

  return (
    <div className="flex-column">
      <FormControl variant="outlined" className="width-100" size="small">
        <InputLabel id="outboundFormatting">
          {t("LBL_EMPTY_RECORD_ACTION")}
        </InputLabel>
        <Select
          className={"width-100"}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          name={"obFormatting"}
          labelId="outboundFormatting"
          label={t("LBL_EMPTY_RECORD_ACTION")}
          id="outboundFormatting"
          value={obFormatting}
          onChange={(e) => {
            setObFormatting(e.target.value);
            debounceChangeHandler("EMPTY_ACTION", e.target.value);
          }}>
          {obFormattingOptions.map((obj, key) => (
            <MenuItem key={key} value={obj.value}>
              {obj.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      
        <FormControl className="margin-top-8">
          <TPCheckbox
            label={t("LBL_SUPPRESS_ARRAY")}
            checked={suppressArray}
            handleCheck={(checked) => {
              setSuppressArray(checked);
              const val = checked ? "TRUE" : "FALSE";
              debounceChangeHandler("SUPPRESS_ARRAY", val);
            }}
          />
        </FormControl>
        <FormControl>
          <TPCheckbox
            label={t("LBL_SUPPRESS_ARRAY_NAME_AND_BRACES")}
            checked={suppressArrayNameandBraces}
            handleCheck={(checked) => {
              setSuppressArrayNameandBraces(checked);
              debounceChangeHandler(null, null, {
                SUPPRESS_ARRAY_NAME: checked ? "TRUE" : "FALSE",
                SUPPRESS_ARRAY_NAME_ONLY: "FALSE",
                SUPPRESS_BRACES: "FALSE",
              });
            }}
          />
        </FormControl>
       
        <FormControl>
            <TPCheckbox
              label={t("LBL_SUPPRESS_ARRAY_NAME_ONLY")}
              checked={suppressArrayName}
              disabled={suppressArrayNameandBraces}
              handleCheck={(checked) => {
                setSuppressArrayName(checked);
                const val = checked ? "TRUE" : "FALSE";
                debounceChangeHandler("SUPPRESS_ARRAY_NAME_ONLY", val);
              }}
            />
          </FormControl>
          <FormControl>
            <TPCheckbox
              label={t("LBL_SUPPRESS_BRACES")}
              checked={suppressArrayBraces}
              disabled={suppressArrayNameandBraces}
              handleCheck={(checked) => {
                setSuppressArrayBraces(checked);
                const val = checked ? "TRUE" : "FALSE";
                debounceChangeHandler("SUPPRESS_BRACES", val);
              }}
            />
          </FormControl>
      </div>
  );
}

export default JSONRecordProperties;
